import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AmbassadorZone } from "../../../domain/entities/assignment-queue";
import { type RouteAssignmentDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listAmbassadorZones = createAsyncThunk<
  AmbassadorZone[],
  void,
  { dispatch: RouteAssignmentDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_AMBASSADOR_ZONES, async (_, { extra }) => {
  return await extra.routeAssignmentRepo.listAmbassadorZones();
});
